<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    v-model="show"
    width="900"
    :fullscreen="$vuetify.display.width <= 600 ? true : false"
    class="public-style"
    destroy-on-close
    align-center
    @close="close"
  >
    <el-form
      ref="ruleFormRef"
      :model="detailData"
      :style="[$vuetify.display.width < 600 ? 'height: 550;' : '']"
      :label-position="`top`"
    >
      <el-space fill style="width: 100%">
        <el-alert type="info" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Reset Elec Region Details</p>
        </el-alert>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="user_full_name" label="User Full Name:">
              <el-input v-model="detailData.user_full_name" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="user_email" label="User Email:">
              <el-input v-model="detailData.user_email" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="form_kind" label="Form Kind:">
              <el-input v-model="detailData.form_kind" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="action_kind" label="Action Kind:">
              <el-input v-model="detailData.action_kind" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="document_id" label="Site ID:">
              <el-input v-model="detailData.document_id" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="log_date" label="Log Date:">
              <el-input :value="formatDateTime(detailData.log_date)" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="site_name" label="Site Name:">
              <el-input :value="siteName" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item class="label-style" prop="comment" label="Comment:">
              <el-input v-model="detailData.comment" type="textarea" :rows="2" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-alert type="warning" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Before Change</p>
        </el-alert>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="before_elec_region" label="Elec Region:">
              <el-input :value="formatRegion(beforeChangeData.elec_region)" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-alert type="success" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Result</p>
        </el-alert>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="old_elec_region" label="Old Elec Region:">
              <el-input :value="formatRegion(resultDisplayData.old_elec_region)" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="new_elec_region" label="New Elec Region:">
              <el-input :value="formatRegion(resultDisplayData.new_elec_region)" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="postcode" label="Postcode:">
              <el-input :value="formatRegion(resultDisplayData.postcode)" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="lat" label="Latitude:">
              <el-input :value="formatRegion(resultDisplayData.lat)" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="lng" label="Longitude:">
              <el-input :value="formatRegion(resultDisplayData.lng)" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </el-space>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="medium"
          class="me-primary"
          @click.stop="close"
          color="#ddf0ac"
        >
          <i class="fa fa-times me-2 me-primary"></i>
          <span class="moderat-btn-apply">Close</span>
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    data_modal: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      show: this.open_modal,
      detailData: {
        id: 0,
        log_date: "",
        form_kind: "",
        action_kind: "",
        document_id: "",
        comment: "",
        user_id: 0,
        user_full_name: "",
        user_email: "",
        result_display: "",
        created_at: "",
        updated_at: "",
        before_change: "",
      },
      beforeChangeData: {
        elec_region: "",
      },
      resultDisplayData: {
        lat: "",
        lng: "",
        postcode: "",
        old_elec_region: "",
        new_elec_region: "",
      },
    };
  },
  computed: {
    siteName() {
      const comment = this.detailData.comment || "";
      const match = comment.match(/Reset elec_region for (.+):\s/i);
      return match ? match[1] : "";
    },
  },
  watch: {
    open_modal: function (newVal) {
      this.show = newVal;
      if (newVal === true) {
        this.parseModalData();
      }
    },
  },
  methods: {
    parseJsonField(raw, fallback) {
      if (!raw) return { ...fallback };
      try {
        return typeof raw === "string" ? JSON.parse(raw) : raw;
      } catch (e) {
        console.error("Error parsing history log JSON:", e);
        return { ...fallback };
      }
    },
    parseModalData() {
      this.beforeChangeData = { elec_region: "" };
      this.resultDisplayData = {
        lat: "",
        lng: "",
        postcode: "",
        old_elec_region: "",
        new_elec_region: "",
      };
      if (!this.data_modal) return;
      const data =
        typeof this.data_modal === "string"
          ? JSON.parse(this.data_modal)
          : this.data_modal;
      this.detailData = { ...data };
      this.beforeChangeData = this.parseJsonField(data.before_change, this.beforeChangeData);
      this.resultDisplayData = this.parseJsonField(data.result_display, this.resultDisplayData);
    },
    formatRegion(value) {
      return value == null || value === "" ? "" : String(value);
    },
    formatDateTime(dateStr) {
      if (!dateStr) return "";
      try {
        const date = new Date(dateStr);
        return date.toLocaleString("en-AU", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
      } catch (e) {
        return dateStr;
      }
    },
    close() {
      this.show = false;
      this.$emit("close_modal", false);
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 30px 10px;
}

.el-input__inner {
  padding: 0 10px !important;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.el-form-item__label {
  margin-bottom: 0 !important;
}

.alert-style {
  margin-bottom: 10px;
}
</style>
